//@ts-ignore
// @ts-nocheck
import { applySnapshot, getParent, getSnapshot, types } from "mobx-state-tree";

const PreferredComms = types.model("PreferredComms", {
  channel: types.optional(types.string, "whatsapp"),
  number: types.optional(types.string, ""),
});

export const ParentFormStore = types
  .model("ParentFormStore", {
    title: types.optional(types.string, "Mr."),
    firstName: types.optional(types.string, ""),
    lastName: types.optional(types.string, ""),
    email: types.optional(types.string, ""),
    phone: types.optional(types.string, ""),
    preferredComms: types.optional(PreferredComms, {
      channel: "whatsapp",
      number: "",
    }),
    medium: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get country() {
        let parent = getParent(self, 1);
        return parent.lessonLocationStore.country;
      },
      get country_code() {
        let parent = getParent(self, 1);
        return parent.lessonLocationStore.country_code;
      },
      get fullData() {
        let data = getSnapshot(self);
        let {
          title,
          firstName,
          lastName,
          email,
          phone,
          medium,
          preferredComms,
        } = data;
        return {
          title,
          firstName,
          lastName,
          email,
          phone,
          medium,
          preferredComms,
        };
      },
    };
  })
  .actions((self) => {
    return {
      updateField(data) {
        applySnapshot(self, data);
      },
    };
  });

export default ParentFormStore;
